import type { NavigateFunction } from "react-router-dom";
import { connectParityApi, type MeetingKind } from "@/api/connectApi";

/**
 * Place an ad-hoc call (from a DM, a group chat or a channel) and open it.
 *
 * The call lives at /meeting/:id, so a refresh keeps you in it and the id can
 * be shared. It used to mount MeetingRoom inline over the chat with no id in
 * the address bar, so a refresh dropped the call. `isCall` makes invitees
 * ring and skips the calendar email that every call used to send.
 */
export async function placeCall(opts: {
    kind: MeetingKind;
    subject: string;
    invitees: string[];
    /** Shown on the "Calling…" screen: the person's name, or the group's. */
    calleeLabel?: string;
    token: string | undefined;
    navigate: NavigateFunction;
}): Promise<void> {
    const meeting = await connectParityApi.createMeeting(
        {
            subject: opts.subject,
            scheduledStart: new Date().toISOString(),
            invitees: opts.invitees,
            kind: opts.kind,
            isCall: true
        },
        opts.token
    );
    await connectParityApi.startMeeting(meeting.id, opts.token);
    opts.navigate(`/meeting/${meeting.id}?call=1`, { state: { calleeLabel: opts.calleeLabel } });
}
